<template>
  <div>
    <h2 class="mb-4 text-center">USER AUTHENTICATION</h2>
    <div class="text-start max-w-500 m-auto">
      <CAlert
        v-if="reqResponse.message"
        class="mt-4"
        :color="reqResponse.type"
        :show="!!reqResponse.message"
      >
        {{ reqResponse.message }}
      </CAlert>
      <div>
        <input
          autocomplete="false"
          name="hidden"
          type="text"
          style="display: none"
        />
        <div v-show="authTypes.standart.isVisible">
          <div class="form-group">
            <div
              class="input-group"
              :class="{
                'is-invalid':
                  v$.form.email.$error || reqResponse.errors['email']
              }"
            >
              <input
                v-model="form.email"
                v-noautofillinput
                autocomplete="false"
                readonly
                onfocus="this.removeAttribute('readonly');"
                class="form-control"
                :class="{
                  'is-invalid':
                    v$.form.email.$error || reqResponse.errors['email']
                }"
                :placeholder="
                  schoolDomains && schoolDomains.length
                    ? 'Just the first part of your email is needed'
                    : 'Email'
                "
                type="text"
              />
              <div v-if="schoolDomains">
                <select
                  v-model="activeDomain"
                  class="form-control border-start-0 pe-5 ps-4"
                  :class="{
                    'border-red':
                      v$.form.email.$error || reqResponse.errors['email']
                  }"
                >
                  <option
                    v-for="(domain, index) in schoolDomains"
                    :key="index"
                    :value="domain"
                  >
                    @{{ domain }}
                  </option>
                </select>
              </div>
            </div>
            <div
              v-if="v$.form.$error && v$.form.email.required.$invalid"
              class="invalid-feedback"
            >
              This field is required
            </div>
            <div v-if="reqResponse.errors['email']" class="invalid-feedback">
              {{ reqResponse.errors["email"][0] }}
            </div>
          </div>

          <div class="form-group">
            <input
              v-model="form.code"
              v-noautofillinput
              class="form-control"
              :class="{
                'is-invalid': v$.form.code.$error || reqResponse.errors['code']
              }"
              placeholder="Kiosk passcode"
              type="password"
            />
            <div
              v-if="v$.form.$error && v$.form.code.required.$invalid"
              class="invalid-feedback"
            >
              This field is required
            </div>
            <div v-if="reqResponse.errors['code']" class="invalid-feedback">
              {{ reqResponse.errors["code"][0] }}
            </div>
          </div>

          <div class="d-flex justify-content-center">
            <div class="w-50" @click="login('standart')">
              <CLoadingButton
                :spinner="isLoading"
                :disabled="isLoading"
                :loading="isLoading"
                class="me-2 btn bg-gradient-blue text-white w-100"
              >
                Submit
              </CLoadingButton>
            </div>
            <button
              class="mx-2 text-uppercase py-3 px-4 fw-bold w-50 btn appointment-pass-btn lh-normal btn-accent-light"
              @click="goToMainScreen"
            >
              Cancel
            </button>
          </div>
        </div>

        <div v-show="authTypes.qrcode.isVisible">
          <div class="form-group">
            <div class="text-center">
              <img
                src="@/assets/images/swiping-card.jpeg"
                alt="scanner"
                width="auto"
                height="80px"
                class="mb-3"
              />
            </div>
            <input
              ref="qrcode"
              v-model="form.qrCode"
              type="password"
              class="form-control"
              :class="{
                'is-invalid':
                  v$.form.qrCode.$error || reqResponse.errors['code']
              }"
              @input="loginWithcode('qrCode')"
              placeholder="Swipe Your Card"
            />

            <div
              v-if="v$.form.$error && v$.form.qrCode.required.$invalid"
              class="invalid-feedback"
            >
              This field is required
            </div>
            <div v-if="reqResponse.errors['code']" class="invalid-feedback">
              {{ reqResponse.errors["code"][0] }}
            </div>
          </div>
        </div>
        <div v-show="authTypes.barcode.isVisible">
          <div class="form-group">
            <div class="text-center">
              <img
                src="@/assets/images/qr-barcode-scanner.png"
                alt="scanner"
                width="auto"
                height="80px"
                class="mb-3"
              />
            </div>
            <input
              ref="barcode"
              v-model="form.barcode"
              type="password"
              class="form-control"
              :class="{
                'is-invalid':
                  v$.form.barcode.$error || reqResponse.errors['code']
              }"
              @input="loginWithcode('barcode')"
              placeholder="Scan Barcode/QR Code"
            />
            <div
              v-if="v$.form.$error && v$.form.barcode.required.$invalid"
              class="invalid-feedback"
            >
              This field is required
            </div>
            <div v-if="reqResponse.errors['code']" class="invalid-feedback">
              {{ reqResponse.errors["code"][0] }}
            </div>
          </div>
        </div>
      </div>

      <span class="d-block text-center fw-bold mt-4 text-value-lg mb-3"
        >Or Authentication using:</span
      >
      <div class="d-flex justify-content-center kiosk-login-methods">
        <div
          class="bg-gradient-blue p-4 kiosk-login-btn"
          @click="setLoginType(auth_type == 'qrcode' ? 'barcode' : 'qrcode')"
        >
          <span
            :class="
              authTypes[auth_type == 'qrcode' ? 'barcode' : 'qrcode'].icon
            "
          />
        </div>
        <div
          class="bg-gradient-blue p-4 ms-4 kiosk-login-btn"
          @click="
            setLoginType(
              auth_type == 'barcode' || auth_type == 'qrcode'
                ? 'standart'
                : 'barcode'
            )
          "
        >
          <span
            :class="
              authTypes[
                auth_type == 'barcode' || auth_type == 'qrcode'
                  ? 'standart'
                  : 'barcode'
              ].icon
            "
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core"
import { requiredIf } from "vuelidate/lib/validators"
import { mapState } from "vuex"
import _ from "underscore"
export default {
  name: "KioskUserLogin",
  props: ["activeKiosk"],
  emits: ["userLoggedIn", "tabChanged"],
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      isLoading: false,
      auth_type: "standart",
      codeLoginTimeOut: null,
      form: {
        email: null,
        code: null,
        qrCode: "",
        barcode: ""
      },
      activeDomain: null,
      reqResponse: {
        type: "",
        message: null,
        errors: {}
      },
      authTypes: {
        standart: {
          isVisible: true,
          icon: "flaticon-user"
        },
        qrcode: {
          isVisible: false,
          icon: "flaticon-credit-card"
        },
        barcode: {
          isVisible: false,
          icon: "flaticon-qr-code"
        }
      }
    }
  },
  validations: {
    form: {
      email: {
        required: requiredIf((model) => !model.qrCode && !model.barcode)
      },
      code: {
        required: requiredIf((model) => !model.qrCode && !model.barcode)
      },
      qrCode: {
        required: requiredIf(
          (model) => !model.email && !model.code && !model.barcode
        )
      },
      barcode: {
        required: requiredIf(
          (model) => !model.email && !model.code && !model.qrCode
        )
      }
    }
  },
  computed: {
    ...mapState({
      options: (state) => {
        const index = _.findIndex(state.schools.activeSchoolModules, {
          name: "Kiosk"
        })
        return index !== -1
          ? JSON.parse(
              state.schools.activeSchoolModules[index].pivot.option_json
            )
          : false
      }
    }),
    isValid() {
      return !this.v$.form.$invalid
    },
    schoolDomains() {
      return this.activeKiosk && this.activeKiosk.school
        ? this.activeKiosk.school.active_domains
        : []
    }
  },
  created() {
    const schoolDomain = this.schoolDomains ? this.schoolDomains[0] : ""
    this.activeDomain =
      this.activeKiosk &&
      this.activeKiosk.defaultDomain != "INVALID DOMAIN NAME"
        ? this.activeKiosk.defaultDomain
        : schoolDomain

    if (this.activeKiosk.loginType) {
      this.setLoginType(this.activeKiosk.loginType)
    }
  },
  methods: {
    login(loginType) {
      this.resetResponseMessages()
      if (this.isValid) {
        this.isLoading = true
        let params = {}
        if (loginType == "standart") {
          params = {
            email: this.activeDomain
              ? this.form.email + "@" + this.activeDomain
              : this.form.email,
            code: this.form.code,
            school_id: this.activeKiosk.school_id
          }
        } else {
          params = {
            code: this.form[loginType],
            school_id: this.activeKiosk.school_id
          }
        }
        this.$store
          .dispatch("kiosks/userLogin", { ...params, type: loginType })
          .then((response) => {
            const data = response.data.data
            if (data) {
              this.setSuccessResponse("Successfully logged.")
              this.$store.commit(
                "kiosks/SET_KIOSK_ACCESS_TOKEN",
                data.access_token
              )
              this.$store.commit("kiosks/SET_ACTIVE_PASS", data.active_pass)
              this.getPass()
              this.$emit("userLoggedIn")
            }
            this.isLoading = false
          })
          .catch((err) => {
            const response = err.response.data
            this.setErrorResponse(response.message, response.errors)
            this.isLoading = false
          })
      } else {
        this.v$.$touch()
      }
    },
    getPass() {
      this.$store.dispatch("kiosks/getPasses").then((res) => {
        const data = res.data
        if (data && data.pass) {
          this.$store.commit("kiosks/SET_ACTIVE_PASS", data.pass)
        }
      })
    },
    loginWithcode(loginType) {
      clearInterval(this.codeLoginTimeOut)
      this.codeLoginTimeOut = setTimeout(() => {
        this.login(loginType)
      }, 500)
    },
    setSuccessResponse(message) {
      this.reqResponse = {
        type: "success",
        message: message ? message : "Success!",
        errors: {}
      }
    },
    setErrorResponse(message, errors) {
      this.reqResponse = {
        type: "danger",
        message: message ? message : "Something went wrong!",
        errors: errors ? errors : {}
      }
    },
    resetResponseMessages() {
      this.reqResponse = {
        type: "",
        message: "",
        errors: {}
      }
    },
    resetForm() {
      this.form = {
        email: null,
        code: null,
        qrCode: "",
        barcode: ""
      }
      // this.v$.$reset()
    },
    goToMainScreen() {
      this.$emit("tabChanged", "mainScreen")
      this.$store.commit("kiosks/SET_CREATE_NEW_PASS_DATA", null)
    },
    setLoginType(type) {
      this.resetResponseMessages()
      this.resetForm()
      this.auth_type = type
      for (const key in this.authTypes) {
        if (Object.hasOwnProperty.call(this.authTypes, key)) {
          this.authTypes[key].isVisible = key == type
        }
      }
      if (this.$refs[type]) {
        setTimeout(() => {
          this.$refs[type].focus({ preventScroll: true })
        }, 500)
      }
    }
  }
}
</script>
